{
  "id": 33,
  "location": "paris",
  "difficulty": "hard",
  "moves": 27,
  "kinds": 6,
  "goals": [
    { "type": "stain" },
    { "type": "collect", "kind": "cookie", "count": 36 }
  ],
  "stars": [4810, 6370],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    "~. ~. ~. ~. ~. ~. ~. ~.",
    "~. ~. ~. ~. ~. ~. ~. ~."
  ],
  "calibration": { "runs": 1000, "winRate": 0.627, "movesLeft": 6.9, "closeLosses": 0.295, "target": 0.5 }
}
